import { inspectionsService } from '@/services/inspections';
import type { CreateInspectionResult } from '@/services/inspections/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateInspection() {
  const queryClient = useQueryClient();

  return useMutation<CreateInspectionResult, Error, string>({
    mutationFn: async (policyId: string) => {
      const response = await inspectionsService.createInspection(policyId);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao criar nova inspeção');
      }

      return response.data;
    },
    onSuccess: async (_data, policyId) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['inspections'] }),
        queryClient.invalidateQueries({ queryKey: ['inspections-summary'] }),
        queryClient.invalidateQueries({
          queryKey: ['policy-inspections', policyId],
        }),
        queryClient.invalidateQueries({
          queryKey: ['proposal-details', policyId],
        }),
        queryClient.invalidateQueries({
          queryKey: ['inspection-records', policyId],
        }),
      ]);
    },
  });
}
